import React from "react";

import { Autocomplete, TextField, TextFieldProps } from "@mui/material";
import { ClientType } from "store/types/user-management";

import { getClientTypeLabel } from "../../../constants";

export interface ListAutocompleteProps {
  options: string[];
  onChange: (value: string) => void;
  sx?: TextFieldProps["sx"];
  charName: string;
  defaultValue?: string;
  value?: string;
  disabled?: boolean;
}

// Values are stored raw; only the display is humanized. getClientTypeLabel is a pass-through for any
// value that isn't a known client type, so applying it to the "Type" characteristic is safe everywhere.
const formatOptionLabel = (charName: string, option: string): string =>
  charName === "Type" ? (getClientTypeLabel(option as ClientType) ?? option) : option;

export const ListAutocomplete: React.FC<ListAutocompleteProps> = ({
  options,
  onChange,
  charName,
  defaultValue,
  value,
  ...props
}) => {
  return (
    <Autocomplete
      fullWidth
      options={options}
      value={value || ""}
      defaultValue={defaultValue}
      disableClearable
      getOptionLabel={(option) => formatOptionLabel(charName, option)}
      renderInput={(params) => <TextField {...params} label={charName} {...props} />}
      onChange={(_, value) => onChange(value || "")}
      {...props}
    />
  );
};
